module.exports = __webpack_public_path__ + "media/images/icons/question_avatar-2014a0b6bf2b230f88eb38b689e470f6.svg";